// import React, { useState, useEffect } from 'react';
// import ProductCard from './ProductCard';

// export default function NewReleaseSection({ products, collectionTitle }) {
//   const [wishlistItems, setWishlistItems] = useState([]);

//   // Load wishlist items from localStorage
//   useEffect(() => {
//     const savedWishlist = localStorage.getItem('wishlist');
//     if (savedWishlist) {
//       try {
//         const parsedWishlist = JSON.parse(savedWishlist);
//         setWishlistItems(parsedWishlist);
//       } catch (error) {
//         console.error('Error parsing wishlist from localStorage:', error);
//       }
//     }
//   }, []);

//   return (
//     <section style={{ padding: '30px 50px' }}>
//       <div style={{ display: 'flex', gap: "10px", justifyContent: 'space-between', marginBottom: '16px' }}>
//         <h2 style={{ fontSize: '18px', fontWeight: 'bold' }}>{collectionTitle}</h2>
//         <a href="/collections/new" style={{ fontSize: '14px', textDecoration: 'underline', color: '#444' }}>
//           View all
//         </a>
//       </div>
//       <div style={{ display: 'grid', width: "100%", overflowY: "hidden",overflow: "scroll", paddingBottom: "20px", gap: '30px', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1.2fr))' }}>
//         {products.map(product => (
//           <ProductCard
//             key={product.id}
//             product={product}
//             isInWishlist={wishlistItems.some(item => item.id === product.id)}
//             onWishlistToggle={() => {
//               const isInWishlist = wishlistItems.some(item => item.id === product.id);
//               if (isInWishlist) {
//                 // Remove from wishlist
//                 const updatedWishlist = wishlistItems.filter(item => item.id !== product.id);
//                 setWishlistItems(updatedWishlist);
//                 localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));
//               } else {
//                 // Add to wishlist
//                 const newWishlistItem = {
//                   ...product,
//                   addedAt: new Date().toISOString()
//                 };
//                 const updatedWishlist = [...wishlistItems, newWishlistItem];
//                 setWishlistItems(updatedWishlist);
//                 localStorage.setItem('wishlist', JSON.stringify(updatedWishlist));
//               }
//             }}
//           />
//         ))}
//       </div>
//     </section>
//   );
// }

import React, { useState, useEffect } from "react";
import ProductCard from "./ProductCard";
// import "./NewReleaseSection.css"; // optional CSS import

export default function NewReleaseSection({ products, collectionTitle }) {
  const [wishlistItems, setWishlistItems] = useState([]);

  // Load wishlist items from localStorage
  useEffect(() => {
    const savedWishlist = localStorage.getItem("wishlist");
    if (savedWishlist) {
      try {
        const parsedWishlist = JSON.parse(savedWishlist);
        setWishlistItems(parsedWishlist);
      } catch (error) {
        console.error("Error parsing wishlist from localStorage:", error);
      }
    }
  }, []);

  // Handle wishlist toggle
  const handleWishlistToggle = (product) => {
    const isInWishlist = wishlistItems.some((item) => item.id === product.id);
    const updatedWishlist = isInWishlist
      ? wishlistItems.filter((item) => item.id !== product.id)
      : [...wishlistItems, { ...product, addedAt: new Date().toISOString() }];

    setWishlistItems(updatedWishlist);
    localStorage.setItem("wishlist", JSON.stringify(updatedWishlist));
  };

  return (
    <section className="new-release-homepage">
      <div className="new-release-header">
        <h2 className="new-release-title">{collectionTitle}</h2>
        <a href="/collections/new" className="new-release-viewall">
          View all
        </a>
      </div>

      <div className="new-release-grid">
        {products.map((product) => (
          <ProductCard
            key={product.id}
            product={product}
            isInWishlist={wishlistItems.some((item) => item.id === product.id)}
            onWishlistToggle={() => handleWishlistToggle(product)}
          />
        ))}
      </div>
    </section>
  );
}
